import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import EnhancedToolbar from '../../../widgets/Toolbar';
import { OnlineModeratorDocumentsForm } from './OnlineModeratorDocumentsForm';
import ViewUtils from '../../../ViewUtils';
import { ViewContainer } from "../../../View.jsx";
import AlertItem from "../../../widgets/AlertItem";

const utils = new ViewUtils();


const formRef = React.createRef();
const toolbarRef = React.createRef();

class AddOnlineModeratorCodeofConduct extends Component {
    constructor(props) {
        super(props)
        let data = {};

        this.state = {
            message: "CODE OF CONDUCT FOR ASSESSORS / MODERATORS",
            model: data,
            messageStyle: "warning",
            nextButtonDisabled: true,
            agreeToCode: false // state for checkbox
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'back', label: 'BACK', tooltip: 'Back to document upload', theme: true },
                        { id: 'submit', label: 'SUBMIT', tooltip: 'SUBMIT', theme: true, disabled: true }
                    ]
                }
            ]
        };
    }

    handleFormValueChange() {
    }

    handleToolbarButtonClick(buttonId) {
       // let formValue = formRef.current.getValue();
        if ("back" === buttonId) {
            this.props.stepHandler(6, false, true);
        } else if ("submit" === buttonId) {
                this.props.stepHandler(6, true, true);  
        }
    }

    handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        this.setState({ agreeToCode: checked });

        // Enable/disable submit button in toolbar
        if (toolbarRef.current) {
            toolbarRef.current.setButtonDisabled("submit", !checked);
        }
    }
    render() {
        return (
            <ViewContainer topPadding="0">
                <p className="legend">
                    Code of Conduct
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <br />
                <br />
                <div style={{ height: "50%", maxHeight: "42vh", overflowY: "auto", border: "1px solid #ccc", padding: "10px" }}>
                    {/* Display Code of Conduct */}
                    <h3>CODE OF CONDUCT FOR ASSESSORS / MODERATORS</h3>
                    <p>
                        All assessors / moderators registered by the BANKSETA will be expected to adhere to a Code of Conduct.
                        This Code of Conduct is built on the basic principles of good assessment / moderation practice and around ensuring that all learners have a fair, valid and reliable assessment experience.
                    </p>
                    <p>The purpose of the Code of Conduct is to:</p>
                    <ul>
                        <li>Define accepted and acceptable assessment / moderation behaviours;</li>
                        <li>Promote high standards of assessment / moderation practice;</li>
                        <li>Provide a benchmark for assessors / moderators to use for evaluating their own practices and behaviours; and</li>
                        <li>Establish a framework for professional assessment / moderation behaviour and responsibilities.</li>
                    </ul>
                    <p>All assessors / moderators will:</p>
                    <ol>
                        <li>Comply with all criteria for registration as assessors / moderators with the BANKSETA;</li>
                        <li>Carry out assessments that are fair, valid and reliable;</li>
                        <li>Abide by the principles of transparency and confidentiality;</li>
                        <li>Comply with and carry out all assessment / moderation responsibilities in accordance with the assessment / moderation criteria and guidelines set for the qualifications and/or unit standards they are registered by the BANKSETA to assess / moderate;</li>
                        <li>Conduct assessment or moderation and perform the duties of an assessor or moderator with the interest of the learners at heart and without compromising the integrity of the assessment/moderation systems in any way;</li>
                        <li>Adhere to all the requirements of the BANKSETA ETQA in promoting the quality of education and training, assessment and moderation for all the learners and giving guidance and support to all learners to achieve their full potential.</li>
                    </ol>

                    {/* Checkbox */}
                    <div style={{ marginTop: "20px" }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={this.state.agreeToCode}
                                onChange={this.handleCheckboxChange}
                            /> I agree to the content of the code of conduct.
                        </label>
                    </div>
                </div>

                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%"></td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar
                                        ref={toolbarRef}
                                        highlight={false}
                                        title=""
                                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                        config={this.toolbarConfig}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(AddOnlineModeratorCodeofConduct)
);
